import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { timeAgo } from "@/lib/api";

export default function RecommendedList({ articles = [] }) {
  return (
    <aside data-testid="recommended-list">
      <div className="mb-4 border-b pb-3" style={{ borderColor: "var(--border)" }}>
        <h2 className="overline">RECOMENDADOS</h2>
      </div>
      <ul className="space-y-4">
        {articles.map((a) => (
          <li key={a.id}>
            <Link to={`/nota/${a.slug}`} className="flex gap-3 group" data-testid={`reco-${a.slug}`}>
              <div className="w-20 h-20 rounded-sm shrink-0 overflow-hidden" style={{ background: "var(--surface-2)" }}>
                {a.featured_image && <img src={a.featured_image} alt="" className="w-full h-full object-cover card-img" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 overline mb-1" style={{ fontSize: "0.62rem" }}>
                  <span className="accent-text">{a.category_slug?.toUpperCase()}</span>
                  <span style={{ color: "var(--text-muted)" }}>·</span>
                  <span style={{ color: "var(--text-muted)" }}>{timeAgo(a.published_at)}</span>
                </div>
                <p className="text-sm font-bold leading-tight group-hover:opacity-80 line-clamp-3" style={{ color: "var(--text)" }}>
                  {a.title}
                </p>
              </div>
              <button onClick={(e) => e.preventDefault()} className="shrink-0 self-start hover:accent-text">
                <Bookmark size={14} />
              </button>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}
